import { AtlasIconData } from "@resource/atlas";
import { serviceGreenhouse, serviceLever } from "@resource/atlas/icons";
import ghIcon from "public/icons/gh-icon-white.svg";

import leverIcon from "../icons/lever-logo-standard.svg";

export const atsIcons: Record<string, string> = {
  greenhouse: ghIcon.src,
  lever: leverIcon.src,
} as const;

const atlasAtsIcons: Record<string, AtlasIconData> = {
  greenhouse: serviceGreenhouse,
  lever: serviceLever,
} as const;

const serviceNames: Record<string, string> = {
  greenhouse: "Greenhouse",
  lever: "Lever",
} as const;

export const getAtlasIconForAts = (ats: string) => atlasAtsIcons[ats];

export const getNameForAts = (ats: string) => serviceNames[ats];

export default function getIconForAts(ats: string) {
  return atsIcons[ats] || "";
}
